import styled from 'styled-components';

export const Greenery = styled.div`
  background: white;
  min-height: 100%;
`
